import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { getToken, setToken, setUserInfo } from '@/utils/auth';
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { login } from '@/api/factofy';
import { message } from 'ant-design-vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'base',
    redirect: '/home',
  },
  {
    path: '/home',
    component: () => import('@/views/home/HomeIndex.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/detail/:id',
    name: 'Detail',
    component: () => import('@/views/detail/FactoryDetail.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/rental-demand',
    name: 'RentalDemand',
    component: () => import('@/views/rental-demand/RentalDemandIndex.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/rental-demand/:id',
    name: 'RentalDemandDetail',
    component: () => import('@/views/rental-demand/RentalDemandDetail.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/recommend',
    name: 'Recommend',
    component: () => import('@/views/recommend/RecommendPage.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/push',
    name: 'Push',
    component: () => import('@/views/push/PushPage.vue'),
  },
  {
    path: '/push/info',
    name: 'PushInfo',
    component: () => import('@/views/push/PushInfo.vue'),
  },
  {
    path: '/user',
    name: 'UserCenter',
    component: () => import('@/views/user/UserCenter.vue'),
  }
];

export const router = createRouter({
  history: createWebHistory(process.env.NODE_ENV === 'production' ? '/lxcf-pc' : '/'),
  routes,
  // strict: true,
  // scrollBehavior: () => ({ left: 0, top: 0 }),
});
export default router;

// 从环境变量中读取并解析 permits 白名单（可选）
const permits = process.env.VUE_APP_PERMITS ? JSON.parse(process.env.VUE_APP_PERMITS) : [];

router.beforeEach(async (to) => {
  NProgress.start()

  const ticketId = to.query.ticketId
  console.log(ticketId)
  // 如果路由不需要认证，并且没有携带ticketId，直接放行
  if (to.meta.requiresAuth === false && (!ticketId || ticketId === 'undefined')) {
    console.log(to.path)
    NProgress.done()
    return true
  }
  // 检查是否有token
  if (getToken()) {
    NProgress.done()
    return true
  }
  try {
    const loginResult = await login(ticketId);
    setToken(loginResult.data.token);
    const userInfo = {
      name: loginResult.data.username,
      phone: loginResult.data.mobile,
      userInfo: loginResult.data.userInfo,
    }
    setUserInfo(JSON.stringify(userInfo));
    NProgress.done();
    return true;
  } catch (error) {
    NProgress.done();
    message.error(error.message || "登录失败，请重试");
    return false;
  }
});